module.exports = __webpack_public_path__ + "Roboto-Bold.6557e141e8221e149c32.eot";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Bold.eot
// module id = ../../../../../src/assets/fonts/Roboto-Bold.eot
// module chunks = styles